import type { JSX } from 'react';

/**
 * LA TETE DE LIA (la mascotte), l'icone d'une conversation de Lia : en-tete et
 * liste de la fenetre de communication, resultats de Canaux. Couleur du texte
 * autour, yeux tournes vers l'app.
 */
export function LiaHead({ size = 18 }: { size?: number }): JSX.Element {
  return <svg viewBox="14 2 88 62" width={size} height={size * 62 / 88} aria-hidden="true" focusable="false">
    <path fill="currentColor" d="M17 64V10Q17 3 22 6L38 28Q43 26 49 26h17q6 0 11 2L93 6q5-3 5 4v54H17Z" />
    <g fill="var(--accent-hover)"><ellipse cx="41" cy="46" rx="8" ry="10" /><ellipse cx="69" cy="46" rx="8" ry="10" /></g>
    <g fill="currentColor"><ellipse cx="37.5" cy="47" rx="3.2" ry="6" /><ellipse cx="65.5" cy="47" rx="3.2" ry="6" /></g>
  </svg>;
}

